module.exports = {
  apiUrl:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:8000'
      : 'https://api.letsfika.today',
};
